// @flow
import React, { PureComponent } from 'react';

import moment from 'moment';
import { handleTagEvent } from 'utils/tagManagerUtils';
import { formatFullDate } from 'utils/dateUtils';

/**
  * $FlowFixMe
  * Original lib -> https://github.com/nwcell/ics.js
  * But ... no package and module export
  * "Open source" 😒
  */
import ics from 'libs/ics';

export type StateProps = {
  club: string,
};

type Props = {
  title: string,
  etat: string,
  dateEffective: Date,
  dateEffectiveStr: string,
  adress: string,
} & StateProps;

class RencontreHeaderFooter extends PureComponent<Props> {
  icsGenerator = ics();

  _renderDownloadCalendar = () => {
    const {
      title,
      dateEffectiveStr,
      adress,
      club,
    } = this.props;

    this.icsGenerator.addEvent(
      title,
      title,
      adress,
      dateEffectiveStr.replace('Z', ''),
      dateEffectiveStr.replace('Z', '')
    );

    const download = () => {
      return this.icsGenerator.download();
    };

    return (
      <button
        type="button"
        onClick={handleTagEvent('calendrier', `ajout_${'test'}`, club, download)}
        className="btn banner__button btn--white"
      >
        <i className="icon icon-calendar is-inline"/>
        <span>Ajouter à mon calendrier</span>
      </button>
    );
  };

  _renderComingSoon = () => {
    return (
      <>
        {this._renderDownloadCalendar()}
        <hr/>
      </>
    );
  };

  _renderDirect = () => {
    return <hr/>;
  };

  _renderEnded = () => {
    const { dateEffective } = this.props;

    return (
      <>
        <hr className="has-date"/>
        <span className="game-date container">{formatFullDate(dateEffective)}</span>
      </>
    );
  };

  render() {
    const { etat, dateEffective } = this.props;

    if (etat === 'Planifiée') {
      if (moment().diff(dateEffective, 'hours') >= 25) {
        return this._renderEnded();
      } else {
        return this._renderComingSoon();
      }
    }

    if (etat === 'Terminée' || etat === 'Score validé') {
      return this._renderEnded();
    }

    return null;
  }
}

export default RencontreHeaderFooter;
